export default theme => ({
  root: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    flex: [[0, 0, `${theme.spacing(6)}px`]],
    marginRight: -theme.spacing(2),
    marginLeft: 'auto',
  },
});
